import React, { useState, useEffect, useCallback } from 'react'
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// import Dropzone from 'react-dropzone'
import { useDropzone } from 'react-dropzone';
import { S3ClientForUserApplications } from "../../../utils/s3Config";
import FormAction from './formAction'
import { toastr } from "react-redux-toastr";
function EducationalHistory (props){

  const { savedSteps, selectedProgramId, selectedProgramLabel } = useSelector((state) => ({
    savedSteps: state.applicationReducer.savedSteps,
    selectedProgramId: state.applicationReducer.selectedProgramId,
    selectedProgramLabel: state.applicationReducer.selectedProgramLabel
  }), shallowEqual);

  const [state, setState] = useState({
    formData: {
      percent_completed: 50,
      prior_education: '',
      educational_history: '',
      educational_resume: null
    },
    prior_educationValid: '',
    educational_historyValid: '',
    educational_resumeValid: '',
    uploader: false,
    isFormDataValid: false,
    isImage: false,
    fileName: ''
  })

  useEffect(()=>{
    window.scrollTo(0, 0)
    if (!!savedSteps.educationalHistory) {
      populateForm();
    }
  },[])

  useEffect(()=>{
    validateForm();
  },[state])

  function populateForm(){
    const educationalHistoryData = savedSteps.educationalHistory;
    if (!!savedSteps.educationalHistory && Object.keys(educationalHistoryData).length > 0) {
      updateForm('prior_education', educationalHistoryData.prior_education)
      updateForm('educational_history', educationalHistoryData.educational_history)
      updateForm('educational_resume', educationalHistoryData.educational_resume)
    }
  }


  const onDrop = useCallback(acceptedFiles => {
    setState({...state, uploader: true})
    // Do something with the files
    if(acceptedFiles && acceptedFiles.length > 0) {
      let file = acceptedFiles[0];
      if (file.length === 0) {
        toastr.error('Error', 'Please upload correct file');
        return;
      }
      if (file.size > 5000000) {
        toastr.error('Error', 'Please upload file less than 5MB');
        return;
      }

      S3ClientForUserApplications
        .uploadFile(file, new Date().getTime())
        .then(data => {
          updateForm('educational_resume', data && data.location ? data.location : null)
          state.isImage = file.type == "image/jpeg" ||  file.type == "image/png";
          state.fileName = file.name || 'File'
          setState({...state, uploader: false})
        })
        .catch(err => {
          toastr.error('Error', 'Resume Uploading Fail');
          setState({...state, uploader: false})
        })
    }
    else {
      setState({ ...state, uploader: false })
      toastr.error('Error', 'Invalid File Type. PDF only');
    }
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: '.pdf'})

  const updateForm = (field, value) => {
    let temp = state.formData
    temp[field] = value
    setState(prevState => ({ ...prevState, formData: temp }));
    _validate(field)
  }

  const _validate = (field) => {
    let regex, valid;
    let value = state.formData[field];
    switch(field){
      case 'prior_education':
        regex = /^.{1,}/;
        valid = regex.test(value)
        break;
      case 'educational_history': case 'educational_resume':
        regex = /^.{2,}/;
        valid = regex.test(value)
        break;
    }
    setState(prevState => ({ ...prevState, [field+"Valid"]: valid }));
  }

  const validateForm = () => {
    let form = state.formData.prior_education.length > 0
      && state.formData.educational_history
      && state.formData.educational_history.length > 0
      // && state.formData.educational_resume
      // && state.formData.educational_resume.length > 0;
    if (state.isFormDataValid != form) {
      setState(prevState => ({ ...prevState, isFormDataValid: form }));
    }
  }

  const removeFile = () => {
    updateForm('educational_resume', '');
  }

    return(
    <>
      	<div className="app-form-container demographic residency">
      		<div className="main-heading bayan-main-heading">
            {selectedProgramLabel}
          </div>
          <div className="sub-heading app-info">
            Educational History
          </div>
          <div className="form-content">
            <div className="input-group">
              <div className="field-label">Prior Education Level*</div>
              <select placeholder="Select" value={state.formData.prior_education} onChange={(e)=>{updateForm('prior_education', e.target.value)}}>
                <option value=''>Select</option>
                <option value={1}>Some College</option>
                <option value={2}>Bachelor's Degree</option>
                <option value={3}>Master's Degree</option>
                <option value={4}>Doctoral's Degree</option>
              </select>
            </div>
            {state.formData.prior_education === false && <div className="field-error">Must select an option.</div>}

            <div className="input-group">
              <div className="field-label">Include the institutions you have attended in chronological order (5 maximum). Indicate the specific degree earned along with major, minor, concentrations or specialties (e.g. University Name, BA Religious Studies, Minor: Music, Concentration: Islamic Studies, May 2016). If you are currently pursuing a degree, indicate the date you expect to receive the degree. If the degree remains incomplete indefinitely, or if you transferred to another institution, leave the date blank.</div>
              <textarea placeholder='Type your answer here'
                value={state.formData.educational_history}
                onChange={(e)=>{updateForm('educational_history', e.target.value)}} />
            </div>
            {state.formData.educational_history === false && <div className="field-error">Must add history.</div>}

            <div className="input-group">
              <div className="field-label">Resume*</div>
              <div className="field-label">Include your Resume or CV here</div>
              {state.uploader && <img src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px', backgroundColor: '#000' }} />}
              <div className="drag-block">
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <p>Drag & Drop a File or Click to Choose</p>
                    <small>(Only PDF documents will be accepted)</small>
                  </div>

              </div>
              {state.formData.educational_resume &&
               <ul className="multi-images">
                <li>
                  <span>
                    {/* {!state.isImage && <h6 alt="Resume">{state.fileName}</h6> } */}
                    {state.isImage ?
                      <img src={state.formData.educational_resume} alt="Resume" />
                    :
                      <img className="doc-icon" src="/icons/file-icon.svg"/>
                    }
                    <div className="thumb_overlay">
                      <div className="thumb_cross" onClick={() => removeFile()}>
                        ✕
                      </div>
                    </div>
                  </span>
                </li>
              </ul>}
          </div>
          {state.formData.educational_resume === false && <div className="field-error">Must add resume.</div>}
          </div>

          <FormAction
            isFormDataValid={state.isFormDataValid}
            formData={state.formData}
            formStep={'educationalHistory'}
            backStep={'academicInfo'}
            nextStep={'toeflScore'}
          />
      	</div>
    </>
    );
  }


// const mapStateToProps = state => ({
//   savedSteps: state.application.savedSteps,
//   reqForm: state.user.data,
// })

export default EducationalHistory;
